import styles from "./TimelineTop.module.css";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";
import { useHistory } from "react-router-dom";
import { Modal } from "@material-ui/core";
import {
    GetTimelines,
    DeleteTimeline,
    UpdateTimelineStatus,
} from "../../store/actions/TimelineActions";
import { useInitFlag } from "../../../components/function/useInitFlag";
import TimelineTopMenuArea from "./TimelineTopMenuArea";
import { TimelineInfo } from "../../models/Timeline";
import EditAndUploadToHubModal from "../../../components/widgets/EditAndUploadToHubModal";
import { UpdateVideo } from "../../store/actions/VideoInfoActions";
import TimelineTopModal from "./TimelineTopModal";
import TimelineTopPageSwiper from "./TimelineTopPageSwiper";
import { isOldSortTimelineList } from "../../../components/function/useTimelineInfoListFlag";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import TimelineTopList from "./TimelineTopList";
import TimelineTopHeader from "./TimelineTopHeader";
import { t } from "i18next";

/**
|--------------------------------------------------
| ビデオ編集トップ画面
|--------------------------------------------------
*/

export default function VideoEditTop() {
    const dispatch = useDispatch();
    const history = useHistory();

    // storeから値取得
    const {
        userInfo,
        timelineInfoList,
        isSuccessUploadCancel,
        isSuccessUploadTimeline,
        isSuccessExportVideo,
    } = useSelector((state: AppState) => ({
        userInfo: state.user.userInfo,
        timelineInfoList: state.timeline.timelineInfoList,
        isSuccessUploadCancel: state.timeline.isSuccessUploadCancel,
        isSuccessUploadTimeline: state.timeline.isSuccessUploadTimeline,
        isSuccessExportVideo: state.videoInfo.isSuccessExportVideo,
    }));

    // タイムラインが書き出された時のデータ
    const [timelineInfo, setTimelineInfo] = useState<TimelineInfo>({
        title: "",
        id: 0,
        name: "",
        created: "",
        updated: "",
        status: "",
        fileUrl: "",
        exportSettings: {
            bitrate: 0,
            denoise: false,
            edTemplateId: 0,
            framerate: 0,
            height: 0,
            opTemplateId: 0,
            width: 0,
        },
    });

    //ページグループエリア
    const [currentTimeline, setCurrentTimeline] = useState<number>(1);
    const [displayTimeline, setDisplayTimeline] = useState<number>(1);

    // タイムライン表示用
    const [timelineList, setTimelineList] = useState<TimelineInfo[]>([]);

    // タイムラインをcineonhubにアップロード
    const [isOpenUploadTimelineModal, setIsOpenUploadTimelineModal] = useState<boolean>(false);

    // 再書き出しパラメーター
    const [timelineId, setTimelineId] = useState<number>(0);
    const [timeline, setTimeline] = useState<TimelineInfo>();

    // 書き出し動画プレビュー
    const [fileUrl, SetFileUrl] = useState("");
    const [visiblePreviewModal, ShowPreviewModal] = useInitFlag(false);

    // アクションfilter
    const [isOpenActionFilter, setIsOpenActionFilter] = useState<boolean>(false);
    const [actionType, setActionType] = useState<string>("");

    // 更新日filterが古い順になっているか
    const [isOld, setIsOld] = useState<boolean>(false);

    // アップロードキャンセルmodal
    const [isOpenUploadCancelModal, setIsOpenUploadCancelModal] = useState<boolean>(false);
    // 書き出しキャンセルmodal
    const [isOpenExportCancelModal, setIsOpenExportCancelModal] = useState<boolean>(false);
    // 書き出し失敗modal
    const [openExportModal, setOpenExportModal] = useState<boolean>(false);
    // タイムライン削除確認modal
    const [isOpenVerifyDeleteModal, setIsOpenVerifyDeleteModal] = useState(false);
    const [deleteTimelineId, setDeleteTimelineId] = useState(0);
    // 再アップロードmodal
    const [isOpenReuploadModal, setIsOpenReuploadModal] = useState<boolean>(false);

    // リストが存在するか
    const [isExistList, setIsExistList] = useState<boolean>(false);
    // 書き出しキャンセルが成功した際のメッセージ
    const [showExportCancelMessage, ShowExportCancelmessage] = useState<boolean>(false);
    const [isCancelExport, setIsCancelExport] = useState<boolean>(false);
    // アップロードキャンセルが成功した際のメッセージ
    const [showUploadCancelMessage, ShowUploadCancelmessage] = useState<boolean>(false);
    const [isCancelUpload, setIsCancelUpload] = useState<boolean>(false);

    // APIコール
    useEffect(() => {
        dispatch(GetTimelines([]));
        // eslint-disable-next-line
    }, [
        // eslint-disable-next-line
        isSuccessUploadCancel === true,
        // eslint-disable-next-line
        isSuccessUploadTimeline === true,
        // eslint-disable-next-line
        isSuccessExportVideo === true,
    ]);

    // BEからのlistを格納
    useEffect(() => {
        if (timelineInfoList) {
            if (actionType !== "") {
                setTimelineList(
                    timelineInfoList.filter((timeline) => timeline.status === actionType)
                );
            } else {
                setTimelineList(timelineInfoList);
            }
            if (timelineInfoList.length > 0) {
                setIsExistList(true);
            } else {
                setIsExistList(false);
            }
        }
        // eslint-disable-next-line
    }, [timelineInfoList]);

    // 書き出しキャンセルメッセージ表示
    useEffect(() => {
        if (isSuccessUploadCancel && isCancelExport) {
            ShowExportCancelmessage(true);
        }
        // eslint-disable-next-line
    }, [isSuccessUploadCancel]);

    // uploadキャンセルメッセージ表示
    useEffect(() => {
        if (isSuccessUploadCancel && isCancelUpload) {
            ShowUploadCancelmessage(true);
        }
        // eslint-disable-next-line
    }, [isSuccessUploadCancel]);

    // 現在表示しているpage設定
    useEffect(() => {
        setDisplayTimeline(currentTimeline > 1 ? currentTimeline * 10 - 10 : 0);
    }, [currentTimeline]);

    // 書き出し状況取得
    useEffect(() => {
        let IS_CREATING = false;
        let timeoutId: NodeJS.Timeout;
        if (timelineInfoList && timelineInfoList.length > 0) {
            IS_CREATING = timelineInfoList.some(
                (timeline) => timeline.status === "CREATING" || timeline.status === "UPLOADING"
            );

            if (IS_CREATING) {
                timeoutId = setTimeout(() => dispatch(GetTimelines([])), 5000);
            }
        }
        // クリーンアップ
        return () => {
            clearTimeout(timeoutId);
        };
        // eslint-disable-next-line
    }, [timelineInfoList]);

    //スライドグループ画像をクリック
    const handleSlideGroupClick = (index: number) => {
        //現在ページ番号設定
        setCurrentTimeline(index);
    };

    // 書き出し動画クリックでプレビューモーダル表示
    const handleClickVideo = (videoFileUrl: React.SetStateAction<string>) => {
        ShowPreviewModal(true);
        SetFileUrl(videoFileUrl);
    };

    // 削除アイコンを押下の場合
    const handleDeleteTimeline = (id: number) => {
        setDeleteTimelineId(id);
        setIsOpenVerifyDeleteModal(true);
    };

    // 削除確認ダイアログを閉じる
    const CloseVerifyDeleteModal = () => {
        setIsOpenVerifyDeleteModal(false);
        setDeleteTimelineId(-1);
    };

    // 削除ダイアログのキャンセルボタンを押下の場合
    const handleCancelDeleteTimeline = () => {
        CloseVerifyDeleteModal();
    };

    // 削除ダイアログのOkボタンを押下の場合
    const handleConfirmDeleteTimeline = () => {
        // タイムライン削除APIコール
        if (userInfo) dispatch(DeleteTimeline(Number(userInfo.id), deleteTimelineId));
        // モーダルを閉じる
        CloseVerifyDeleteModal();
    };

    // タイムラインアップロードモーダルを表示
    const OpenUploadTimelineModal = (timeline: TimelineInfo) => {
        setTimelineInfo(timeline);
        setIsOpenUploadTimelineModal(true);
        ShowUploadCancelmessage(false);
        ShowExportCancelmessage(false);
    };

    // errorメッセージ押下時
    const handleErrorMessage = (timeline: TimelineInfo) => {
        setTimelineId(timeline.id);
        setTimeline(timeline);
        setOpenExportModal(true);
    };

    // 書き出し中メッセージ押下
    const handleExportMessage = (id: number) => {
        setIsOpenExportCancelModal(true);
        setTimelineId(id);
        ShowUploadCancelmessage(false);
        ShowExportCancelmessage(false);
    };

    // アップロード中メッセージ押下
    const handleUploadingMessage = (id: number) => {
        setIsOpenUploadCancelModal(true);
        setTimelineId(id);
    };

    // 完了メッセージ押下
    const handleCompleted = (timeline: TimelineInfo) => {
        setTimelineInfo(timeline);
        setIsOpenReuploadModal(true);
    };

    // timeline書き出し失敗modalから編集ボタン押下時
    const goToEditTimeline = () => {
        history.push("./editTimeline/" + timelineId);
    };

    // アクションfilter押下時
    const handleActionType = (type: string) => {
        setActionType(type);
        setIsOpenActionFilter(false);
        setCurrentTimeline(1);
        if (timelineInfoList && timelineInfoList.length > 0) {
            if (type === "") {
                if (
                    isOldSortTimelineList(
                        timelineInfoList[0].updated,
                        timelineInfoList[timelineInfoList.length - 1].updated
                    )
                ) {
                    setTimelineList(isOld ? timelineInfoList : timelineInfoList.reverse());
                } else {
                    setTimelineList(isOld ? timelineInfoList.reverse() : timelineInfoList);
                }
            } else {
                const result: TimelineInfo[] = timelineInfoList.filter((timeline) => {
                    return timeline.status === type;
                });
                if (result && result.length > 0) {
                    if (
                        isOldSortTimelineList(result[0].updated, result[result.length - 1].updated)
                    ) {
                        setTimelineList(isOld ? result : result.reverse());
                    } else {
                        setTimelineList(isOld ? result.reverse() : result);
                    }
                } else {
                    setTimelineList([]);
                }
            }
        }
    };

    // アップロードキャンセル
    const UploadCancel = () => {
        dispatch(UpdateTimelineStatus(timelineId, "UPLOAD_CANCELING"));
        setIsOpenUploadCancelModal(false);
        ResetInput();
        setIsCancelUpload(true);
    };

    // 書き出しキャンセル
    const ExportCancel = () => {
        dispatch(UpdateTimelineStatus(timelineId, "CREATE_CANCELING"));
        setIsOpenExportCancelModal(false);
        ResetInput();
        setIsCancelExport(true);
    };

    // 再書き出しボタン押下
    const ExportTimeline = () => {
        if (!timeline) return;
        if (userInfo) {
            dispatch(
                UpdateVideo({
                    id: timeline.id,
                    bitrate: timeline.exportSettings.bitrate,
                    width: timeline.exportSettings.width,
                    height: timeline.exportSettings.height,
                    framerate: timeline.exportSettings.framerate,
                    denoise: timeline.exportSettings.denoise,
                    opTemplateId: timeline.exportSettings.opTemplateId,
                    edTemplateId: timeline.exportSettings.edTemplateId,
                    userId: Number(userInfo.id),
                })
            );
            setOpenExportModal(false);
            ResetInput();
        }
    };

    // 再書き出しinputreset
    const ResetInput = () => {
        setTimelineId(0);
    };

    return (
        <>
            <div className={styles.root}>
                <div className={styles.row}>
                    <TimelineTopMenuArea menuType="プロジェクト" />
                    <div className={styles.project}>
                        {/* TimelineTopheader */}
                        <TimelineTopHeader
                            timelineList={timelineList}
                            timelineInfoList={timelineInfoList}
                            handleActionType={handleActionType}
                            setIsOpenActionFilter={setIsOpenActionFilter}
                            isOpenActionFilter={isOpenActionFilter}
                            isOld={isOld}
                            setIsOld={setIsOld}
                            setTimelineList={setTimelineList}
                        />
                        {/* 未編集のタイムライン一覧表示 */}
                        <TimelineTopList
                            timelineList={timelineList}
                            displayTimeline={displayTimeline}
                            handleClickVideo={handleClickVideo}
                            handleExportMessage={handleExportMessage}
                            OpenUploadTimelineModal={OpenUploadTimelineModal}
                            handleUploadingMessage={handleUploadingMessage}
                            handleCompleted={handleCompleted}
                            handleErrorMessage={handleErrorMessage}
                            handleDeleteTimeline={handleDeleteTimeline}
                            isExistList={isExistList}
                            timelineInfoList={timelineInfoList}
                        />
                        <TimelineTopPageSwiper
                            handleSlideGroupClick={handleSlideGroupClick}
                            timelineList={timelineList}
                            currentTimeline={currentTimeline}
                        />
                    </div>
                </div>
            </div>
            {/* 動画previewModal */}
            <Modal
                open={visiblePreviewModal}
                onClose={() => ShowPreviewModal(false)}
                className={styles.previewModal}
            >
                <div className={styles.previewModalVideo}>
                    <video
                        autoPlay
                        controls
                        src={fileUrl}
                        controlsList="nofullscreen nodownload"
                        disablePictureInPicture
                        className={styles.previewVideo}
                    ></video>
                </div>
            </Modal>
            {/* 動画アップロードModal */}
            <EditAndUploadToHubModal
                visibleModal={isOpenUploadTimelineModal}
                showModal={setIsOpenUploadTimelineModal}
                timelineInfo={timelineInfo}
            />
            {/* 削除確認モーダル表示 */}
            <TimelineTopModal
                message={t("タイムラインを削除しますか？")}
                leftButtonText={t("キャンセル")}
                rightButtonText={t("削除")}
                leftButtonClick={handleCancelDeleteTimeline}
                rightButtonClick={handleConfirmDeleteTimeline}
                open={isOpenVerifyDeleteModal}
                onClose={CloseVerifyDeleteModal}
            />
            {/* エラーmodal */}
            <TimelineTopModal
                message={t("エラーが発生しました。")}
                leftButtonText={t("編集")}
                rightButtonText={t("再度書き出し")}
                leftButtonClick={goToEditTimeline}
                rightButtonClick={ExportTimeline}
                open={openExportModal}
                onClose={() => setOpenExportModal(false)}
            />
            {/*  アップロードキャンセルmodal*/}
            <TimelineTopModal
                message={t("アップロードをキャンセルしますか？")}
                leftButtonText={t("いいえ")}
                rightButtonText={t("はい")}
                leftButtonClick={() => setIsOpenUploadCancelModal(false)}
                rightButtonClick={UploadCancel}
                open={isOpenUploadCancelModal}
                onClose={() => setIsOpenUploadCancelModal(false)}
            />
            {/*  書き出しキャンセルmodal*/}
            <TimelineTopModal
                message={t("書き出しをキャンセルしますか？")}
                leftButtonText={t("いいえ")}
                rightButtonText={t("はい")}
                leftButtonClick={() => setIsOpenExportCancelModal(false)}
                rightButtonClick={ExportCancel}
                open={isOpenExportCancelModal}
                onClose={() => setIsOpenExportCancelModal(false)}
            />
            {/*  再アップロードmodal*/}
            <TimelineTopModal
                message={t("再アップロードしますか？")}
                leftButtonText={t("いいえ")}
                rightButtonText={t("はい")}
                leftButtonClick={() => setIsOpenReuploadModal(false)}
                rightButtonClick={() => {
                    setIsOpenReuploadModal(false);
                    setIsOpenUploadTimelineModal(true);
                }}
                open={isOpenReuploadModal}
                onClose={() => setIsOpenReuploadModal(false)}
            />
            <Snackbar
                autoHideDuration={5000}
                open={showExportCancelMessage}
                onClose={() => ShowExportCancelmessage(false)}
            >
                <Alert severity="success">
                    <div>{t("書き出しをキャンセルしました。")}</div>
                </Alert>
            </Snackbar>
            <Snackbar
                autoHideDuration={5000}
                open={showUploadCancelMessage}
                onClose={() => ShowUploadCancelmessage(false)}
            >
                <Alert severity="success">
                    <div>{t("アップロードをキャンセルしました。")}</div>
                </Alert>
            </Snackbar>
        </>
    );
}
